import {
  Button,
  ButtonGroup,
  Content,
  Dialog,
  Divider,
  Heading,
  useDialogContainer,
  TextField,
  Flex,
} from "@adobe/react-spectrum";
import React, { useState } from "react";
import PropTypes from "prop-types";

export default function ConfirmRemoveDialog({ value, onClose }) {
  const [comment, setComment] = useState("");

  const dialog = useDialogContainer();

  const handleConfirm = () => {
    onClose(value, comment);
    setComment("");
    dialog.dismiss();
  };

  const handleCancel = () => {
    setComment("");
    dialog.dismiss();
  };

  return (
    <Dialog>
      <Heading>Remove Node</Heading>
      <Divider />
      <Content>
        <Flex marginBottom="15px">
          Removing this node from the hierarchy will create an orphan account.
          Proceed to remove?
        </Flex>
        <TextField
          label="Reason"
          width="100%"
          value={comment}
          onChange={setComment}
        />
      </Content>
      <ButtonGroup>
        <Button onPress={handleCancel} variant="secondary">
          Cancel
        </Button>
        <Button onPress={handleConfirm} variant="positive">
          Remove
        </Button>
      </ButtonGroup>
    </Dialog>
  );
}

ConfirmRemoveDialog.propTypes = {
  value: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
      PropTypes.number,
      PropTypes.array,
      PropTypes.objectOf(PropTypes.string),
    ])
  ).isRequired,
  onClose: PropTypes.func.isRequired,
};
